var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.245361 2.83562C0.245361 1.27397 1.66186 0 3.45331 0C5.24477 0 6.66127 1.27397 6.66127 2.83562C6.66127 4.39726 5.24477 5.67123 3.45331 5.67123C1.66186 5.67123 0.245361 4.39726 0.245361 2.83562ZM20.118 7.31507C17.7433 7.31507 16.3268 8.17808 14.827 10.0685V7.84932H9.41094V24H14.8686V15.2466C14.8686 13.3973 15.8268 11.589 17.9933 11.589C20.1597 11.589 21.4512 13.3973 21.4512 15.2055V24H26.9089V14.8356C26.9089 8.46575 22.5344 7.31507 20.118 7.31507ZM0.724472 7.84932H6.1405V24H0.724472V7.84932Z","fill":"#9D4DBD"}));
}

Linkedin.defaultProps = {"width":"27","height":"24","viewBox":"0 0 27 24","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
